var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.199,
    height: 14.674,
    viewBox: "0 0 11.199 14.674",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Bold",
    d: "M1.12,19.154V5.48H6.59a4.289,4.289,0,0,1,2.365.584,3.545,3.545,0,0,1,1.32,1.467,4.138,4.138,0,0,1,.418,1.785,3.315,3.315,0,0,1-.518,1.909,2.486,2.486,0,0,1-1.42,1.016v-.475a2.962,2.962,0,0,1,1.923,1.187,3.524,3.524,0,0,1,.641,2.061,4.886,4.886,0,0,1-.451,2.156A3.315,3.315,0,0,1,9.5,18.627a4.613,4.613,0,0,1-2.317.527Zm2.621-2.431H6.913a1.909,1.909,0,0,0,.931-.223,1.627,1.627,0,0,0,.641-.627,1.878,1.878,0,0,0,.233-.954,1.831,1.831,0,0,0-.2-.864,1.456,1.456,0,0,0-.6-.6,2.048,2.048,0,0,0-1-.223H3.741Zm0-5.907H6.552a1.9,1.9,0,0,0,.779-.152,1.2,1.2,0,0,0,.541-.47,1.525,1.525,0,0,0,.2-.821,1.507,1.507,0,0,0-.389-1.054,1.451,1.451,0,0,0-1.13-.427H3.741Z",
    transform: "translate(-0.62 -4.98)",
    fill: "#707070",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBold);
export default __webpack_public_path__ + "static/media/Bold.3e93e9ca15553886a245dd0c9d8f41a5.svg";
export { ForwardRef as ReactComponent };